/** @jsx jsx */
import { css, jsx } from '@emotion/core'

import { Button } from '@livechat/design-system'

const containerCss = css`
  width: 600px;

  :focus {
    outline: 0;
  }

  .lc-btn {
    border-color: #d0d2d5;
    box-shadow: none;
    color: #424d57;
    font-weight: 400;
  }
`

const NextField = ({ addField, label }) => {
  return (
    <div css={containerCss}>
      <Button type="ghost" onClick={addField} data-cy="add-field">
        {label}
      </Button>
    </div>
  )
}

export default NextField
